<form [formGroup]="priceForm" (ngSubmit)="onSubmit()">
    <ng-container formArrayName="pricedetail">
      <div *ngFor="let detail of pricedetail.controls; let i = index" [formGroup]="detail">

        <div fxLayout.xs="column"  fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Title 1</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-title1' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title1" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Title 2</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-title2' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title2" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Title 3</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-title3' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title3" />
                </mat-form-field>
            </div>
            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Title 4</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-title4' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="title4" />
                </mat-form-field>
            </div>            
        </div>


        <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Starter Price Annualy</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-s-price-annualy' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="s_price_annualy" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Profession Price Annualy</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-p-price-annualy' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="p_price_annualy" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Advanced Price Annualy</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-a-price-annualy' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="a_price_annualy" />
                </mat-form-field>
            </div>
            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Ultimate Price Annualy</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-u-price-annualy' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="u_price_annualy" />
                </mat-form-field>
            </div>            
        </div>

            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
                <div fxFlex.xs="100" fxFlex="25">
                    <mat-form-field fxFlex>
                        <mat-label>Starter Charge detail yearly</mat-label>
                        <input [attr.guide]="'price-table-plan5-inp-s-charge-year' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="s_charge_year" />
                    </mat-form-field>
                </div>
    
                <div fxFlex.xs="100" fxFlex="25">
                    <mat-form-field fxFlex>
                        <mat-label>Profession Charge detail yearly</mat-label>
                        <input [attr.guide]="'price-table-plan5-inp-p-charge-year' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="p_charge_year" />
                        
                    </mat-form-field>
                </div>
    
                <div fxFlex.xs="100" fxFlex="25">
                    <mat-form-field fxFlex>
                        <mat-label>Advanced Charge detail yearly</mat-label>
                        <input [attr.guide]="'price-table-plan5-inp-a-charge-year' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="a_charge_year" />
                    </mat-form-field>
                </div>

                <div fxFlex.xs="100" fxFlex="25">
                    <mat-form-field fxFlex>
                        <mat-label>Ultimate Charge detail yearly</mat-label>
                        <input [attr.guide]="'price-table-plan5-inp-u-charge-year' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                        [autocomplete]="'off'" matInput
                        formControlName="u_charge_year" />
                        
                    </mat-form-field>
                </div>

            </div>            


        <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Button name</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-s-button' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="s_button" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Button link</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-p-button' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="p_button" />
                    
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Background color</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-a-button' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="a_button" />
                </mat-form-field>
            </div>
         </div>                        

         <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Starter Sub title</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-s-subtitle' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="s_subtitle" />
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Profession Sub title</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-p-subtitle' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="p_subtitle" />
                    
                </mat-form-field>
            </div>

            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Advanced Sub title</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-a-subtitle' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="a_subtitle" />
                </mat-form-field>
            </div>
            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Ultimate Sub title</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-u-subtitle' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="u_subtitle" />
                </mat-form-field>
            </div>            
        </div>  

        <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>title fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-toptitle-font' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="Toptitle_font" />
                </mat-form-field>
            </div>


            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>subtitle fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-subtitle-font' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="subtitle_font" />
                </mat-form-field>
            </div>
            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>Toptitle Mob fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-toptitle-mobfont' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="Toptitle_mobfont" />
                </mat-form-field>
            </div>
            <div fxFlex.xs="100" fxFlex="25">
                <mat-form-field fxFlex>
                    <mat-label>subtitle Mob fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-subtitle-mobfont' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="subtitle_mobfont" />
                </mat-form-field>
            </div>

        </div>  


        <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10">
            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>column backGround</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-column-color' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="column_color" />
                </mat-form-field>
            </div>
            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Button fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-button-font' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="button_font" />
                </mat-form-field>
            </div>            
            <div fxFlex.xs="100" fxFlex="33">
                <mat-form-field fxFlex>
                    <mat-label>Button Mob fontsize</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-button-mobfont' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="button_mobfont" />
                </mat-form-field>
            </div>            

        </div>


        <ng-container formArrayName="list_detail">
          <div *ngFor="let item of detail.get('list_detail').controls; let j = index" [formGroup]="item" style="border: 1px solid lightgray;padding: 15px;margin: 5px;">
            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10px">
                <!-- <mat-form-field fxFlex>
                    <mat-label>Sub Title</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-sub-title' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="sub_title" />
                </mat-form-field> -->

                <mat-form-field fxFlex>
                    <mat-label>Starter</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-starters' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="starters" />
                </mat-form-field>

                <mat-form-field fxFlex>
                    <mat-label>Profession</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-professions' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="professions" />
                </mat-form-field>

                <mat-form-field fxFlex>
                    <mat-label>Advanced</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-advanceds' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="advanceds" />
                </mat-form-field>
                <mat-form-field fxFlex>
                    <mat-label>Ultimate</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-ultimates' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="ultimates" />
                </mat-form-field>                
            </div>
            <div fxLayout.xs="column" fxLayout="row" fxLayoutGap="10px">
                <mat-form-field fxFlex>
                    <mat-label>icon view1</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-option1' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="option1" />
                </mat-form-field>

                <mat-form-field fxFlex>
                    <mat-label>icon view2</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-option2' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="option2" />
                </mat-form-field>
                <mat-form-field fxFlex>
                    <mat-label>icon view3</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-option3' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="option3" />
                </mat-form-field>

                <mat-form-field fxFlex>
                    <mat-label>icon view4</mat-label>
                    <input [attr.guide]="'price-table-plan5-inp-option4' + '__' + sanitizeUrl(url)" trim="blur" (keydown.enter)="$event.preventDefault()"
                    [autocomplete]="'off'" matInput
                    formControlName="option4" />
                </mat-form-field>
                <div fxFlex>
                    <button [attr.guide]="'price-table-plan5-btn-1' + '__' + sanitizeUrl(url)" mat-raised-button color="warn" (click)="deleteListDetail(i, j)">Delete</button>
                </div>
            </div>

          </div><br/>
          <button [attr.guide]="'price-table-plan5-btn-2' + '__' + sanitizeUrl(url)" mat-raised-button (click)="addListDetail(i)">Add List</button>
        </ng-container><br/>
      </div><br/>
      <!-- <button [attr.guide]="'price-table-plan5-btn-3' + '__' + sanitizeUrl(url)" mat-raised-button (click)="addPricingDetails()">Add Pricing Detail</button> -->
    </ng-container><br/>
    <button [attr.guide]="'price-table-plan5-btn-4' + '__' + sanitizeUrl(url)" mat-raised-button color="primary" type="submit" style="margin-top: 10px;margin-bottom: 10px;" >{{btntext}}</button>
  </form>
  